















import Vue from 'vue';
import { Component } from 'vue-property-decorator';
import GoogleMapsApiLoader from 'google-maps-api-loader';

@Component({
  name: 'GoogleMapLoader',
  props: {
    apiKey: String,
    mapConfig: Object,
  },

  data() {
    return {
      google: null,
      map: null,
    };
  },

  async mounted() {
    this.google = await GoogleMapsApiLoader({
      apiKey: process.env.VUE_APP_GOOGLE_MAPS_API_KEY,
    });
    this.initializeMap();
  },

  methods: {
    initializeMap() {
      const mapContainer = this.$refs.googleMap;
      this.map = new this.google.maps.Map(mapContainer, (this as any).mapConfig);
    },
  },
})
export default class GoogleMapLoader extends Vue {}
